import 'es5-shim';
import 'es5-shim/es5-sham';
import 'console-polyfill';


import React from 'react';
import ReactDOM from 'react-dom';

import '../styles/fonts.scss';
import '../styles/basestyle.scss';


import Mainframe from './mainframe';


ReactDOM.render(<Mainframe/>, document.getElementById('app'));
import '../styles/break-points.scss';



// WEBPACK FOOTER //
// ./src/scripts/main.js